import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useCallback, useEffect } from "react";
import styled, { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { actions, useAppDispatch, useAppSelector } from "../../../../../redux";
import { FlexColumn } from "../../../../Common/Styles";
import { FollowersFollowingProps } from "./FollowersFollowing";

export const FollowModalHeading = (
  props: FollowersFollowingProps.FollowModalHeading
) => {
  const dispatch = useAppDispatch();
  const { filterText, setFilterText, type, showModal } = props;
  const { typography } = useTheme();
  const { searchUsers, searchUsers_API_STATUS } = useAppSelector(
    (state) => state.connections
  );

  const handleSearch = useCallback(() => {
    if (!filterText || !filterText.length) return;
    if (type === "none") return;
    if (searchUsers_API_STATUS !== "idle") return;
    API_CALLS.CONNECTIONS.searchUsers({
      page: searchUsers.page,
      pageSize: searchUsers.pageSize,
      query: filterText,
      type,
    });
    //eslint-disable-next-line
  }, [filterText, type, searchUsers_API_STATUS, searchUsers.page]);

  const debouncedSearch = useDebounce(handleSearch);
  useEffect(() => {
    debouncedSearch();
  }, [filterText, type, debouncedSearch]);

  const idPrefix = "followerFollowing";
  const fieldName = `Search`;
  const searchInputId = `${idPrefix}_${fieldName}`;
  useEffect(() => {
    const element = document.getElementById(searchInputId);
    if (showModal && element) element.focus();
  }, [showModal, searchInputId]);

  return (
    <Heading $gapInPx={8}>
      <Components.Text
        text={type === "followers" ? "Followers" : "Following"}
        style={{ tokenStyle: typography.Heading.XS }}
        letterSpacing="letter-spacing-100"
        lineHeight="line-height-200"
        fontWeight="font-weight-semibold"
      />
      <Inputs.Search
        fieldName={fieldName}
        fieldType="Search"
        idPrefix={idPrefix}
        placeholder="Search"
        handleSelect={() => {}}
        isRequired={false}
        onChangeHandler={(value) => {
          dispatch(actions.connections.resetSearchUsers());
          setFilterText(value);
        }}
        value={filterText}
        debounceTime={0}
        searchFunction={() => {}}
        iconClickHandler={() => setFilterText("")}
      />
    </Heading>
  );
};

const Heading = styled(FlexColumn)``;
